import axios from '@/http/axios/index.js'


export default {
    getDocumentRequest(payload) {
        return axios.get('rps/requests', { params: payload }).then(res => res.data)
    },
    updateDocumentRequest(payload) {
        return axios.post('rps/request/status', payload).then(res => res.data)
    },
    deleteDocumentRequest(payload) {
        return axios.delete('rps/request/destroy', { params: payload }).then(res => res.data)
    },
    getClients(payload) {
        return axios.get('rps/client/catalog', { params: payload }).then(res => res.data)
    },
    getDocument(payload) {
        return axios.get('rps/requests/get-document', { params: payload }).then(res => res.data)
    },
    addRequest(payload) {
        return axios.post('rps/request/store', payload).then(res => res.data)
    },
    addRequestAuto(payload) {
        return axios.post('rps/request/autogenerated', payload).then(res => res.data)
    },
    uploadFiles(payload) {
        return axios.post('rps/updaload-file', payload, {
            headers: { 'Content-Type': 'multipart/form-data' },
            processData: false,
            contentType: false
        }).then(res => res.data)
    },
    getFiles(payload) {
        return axios.get('rps/get-files', { params: payload }).then(res => res.data)
    },

}   